import React from 'react';
import { Slang } from '../../helpers';


const Research = () => {

    const lang = Slang('home.search');

    return <div className="gradient-x-three-sm-primary">
        <div className="container content-space-2 rounded">
            <form>
                <div className="input-card input-card-sm mb-3">
                    <div className="input-card-form">
                        <label htmlFor="jobTitleForm" className="form-label visually-hidden">{lang('placeholder')} </label>
                        <div className="input-group input-group-merge">
                            <span className="input-group-prepend input-group-text">
                                <i className="bi-search"></i>
                            </span>
                            <input type="text" className="form-control" id="jobTitleForm"
                                placeholder={lang('placeholder')} aria-label={lang('placeholder')} />
                        </div>
                    </div>

                    <button type="button" className="btn btn-primary">{lang('btn')}</button>
                </div>
            </form>

            <div className="row align-items-center">
                <div className="col-md-auto mb-3 mb-lg-0">
                    <h6 className="mb-1">{lang('limit')}:</h6>
                </div>

                <div className="col-md mb-3 mb-lg-0">
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" id="jobSearchToCheckbox1" value="products" />
                        <label className="form-check-label" htmlFor="jobSearchToCheckbox1">{lang('r1')}</label>
                    </div>

                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="checkbox" id="jobSearchToCheckbox2" value="services" />
                        <label className="form-check-label" htmlFor="jobSearchToCheckbox2">{lang('r2')}</label>
                    </div>
                </div>

                {/* <div className="col-md-auto">
                    <div className="form-check form-switch">
                        <input className="form-check-input" type="checkbox" id="remoteOnlySwitch" />
                        <label className="form-check-label" htmlFor="remoteOnlySwitch">Remote only</label>
                    </div>
                </div> */}
            </div>
        </div>
    </div>;
}

export default Research;
